import React, { useState, useCallback, useEffect, useMemo } from 'react';
import Layout from 'components/layouts';
import { useLocation } from 'react-router-dom';
import { useSettingsStepContext } from 'context/SettingsStepContext';
import SettingsApi from 'libs/api/settings';
import PageTitle from 'components/organisms/PageTitle';
import FormFooter from 'components/molecules/FormFooter';
import SettingsMainFormLoader from 'components/atoms/Loaders/FormLoaders/SettingsMainForm';
import { useServiceForm } from 'hooks/formStates/settings';
import ServicesContent from 'components/organisms/settings/ServicesContent';
import TimesForm from 'components/molecules/settings/TimesForm';
import { ExceptionsWrapper } from 'components/molecules/settings/styled';
import { InputTitle } from 'components/atoms/styleds';

import {
  StyledFormBlockWrapper,
  StyledMenuWrapper,
} from 'components/atoms/Wrappers';
import { Header, HeaderTitle } from 'components/organisms/SettingsForm/styled';
import { useSettings } from 'redux/settings/use-settings';
import { useCommon } from 'redux/common/use-common';
import { useCurrentRestaurant } from 'redux/restaurant/use-restaurant';
import {
  StyledBodyText,
  StyledBodyTextBold,
} from 'components/molecules/Modal/styled';
import { deliveryKeys, mainTabsKeys } from 'common/constants/settings';
import SetupSettings from '../../molecules/settings/v2/SetupSettings';
import { Divider, InputDescription, Title } from '../../atoms/styleds';
import TabSwitcher from 'components/molecules/TabSwitcher';
import RouterHelper from 'services/RouterHelper';
import routeCodes from 'common/constants/route-codes';
import Ipratico from 'components/organisms/settings/Ipratico';
import Modal from 'components/molecules/Modal';
import { useDynamicApi } from 'hooks/api/dynamic-api';
import { fetchAllPagesFromListApi } from 'utils/pagination';
import IpraticoApi from 'libs/api/ipratico';
import { StyledInput } from 'components/atoms/Chip/styled';
import Button from 'components/atoms/Button';
import ServiceForm from 'components/molecules/settings/v2/ServiceForm';
import Input from 'components/atoms/Input';
import RestaurantServicesApi from 'libs/api/restaurantServices';
import ServicesApi from 'libs/api/services';
import ServicesList from 'components/molecules/settings/v2/ServicesList';
import { nanoid } from 'nanoid';
import UIHelper from 'services/UIHelper';
import { StyledFlexbox } from 'components/atoms/Flexbox/styled';
import SwitchCheckbox from 'components/atoms/SwitchCheckbox';
import Typography from 'components/atoms/Typography';

const getTab = (pathname) => {
  if (pathname.includes('configs')) {
    return mainTabsKeys.configs;
  }
  if (pathname.includes('time')) {
    return mainTabsKeys.times;
  }
};

const getConfigTab = (pathname) => {
  if (pathname.includes('delivery')) {
    return deliveryKeys.delivery;
  }
  return deliveryKeys.reservation;
};

export const SettingTabKeys = {
  main: 'main',
  ipratico: 'ipratico',
};

const SettingsMainLayout = ({
  children,
  onSubmitAction,
  onChange,
  setOpeningHourErrors,
  onSelectConfig,
  localState = {},
  changeDeliveryDayConfig,
  deliveryActiveTab,
  deliveryDates,
  fetchDeliveryDates,
  onChangeDeliveryTab,
  onChangeMaximum,
  onChangeExceptionDay,
  onAddExceptionData,
  isLoading,
  localUpdateInProcess,
  showFooter = true,
  isAutoSave = false,
  openingHourErrors,
  onCancel,
  onDeleteException,
  onAddNewException,
  exceptionErrors,
  isSuperAdmin,
  setDeliveryDates,
}) => {
  const { pathname } = useLocation();
  const [tabConfigured, setTabConfigured] = useState(false);
  const [mainActiveTab, setMainActiveTab] = useState(SettingTabKeys.main);
  const [dataForRequest, setDataForRequest] = useState({});
  const [deliveryZips, setDeliveryZips] = useState([]);
  const [ipraticoData, setIpraticoData] = useState({});
  const [ipraticoErrors, setIpraticoErrors] = useState(null);
  const [ipraticoInProcess, setIpraticoInProcess] = useState(false);
  const [needConfirm, setNeedConfirm] = useState(false);
  const [configTabKey, setConfigTabKey] = useState(getConfigTab(pathname));
  const [configChangeInProcess, setConfigChangeInProcess] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [showContent, setShowContent] = useState(true);
  const { step, setStep } = useSettingsStepContext();
  const [openCreateService, setOpenCreateService] = useState(false);
  const [openAutoCreateService, setOpenAutoCreateService] = useState(false);

  useEffect(() => {
    if (step === 1) {
      setOpenAutoCreateService(false);
    }
  }, [step]);

  const [serviceLocalState, setServiceLocalState] = useState({
    id: null,
    title: '',
    total_seats: '',
    service_duration: '180_minutes',
    prereservation_time: 'none',
    confirmation_type: 'none',
    slot_duration: '30_minutes',
    slot_seats: '',
    price: '1',
    booking_max_person_count: '',
    auto_confirmation: true,
    service_opening_hours_attributes: [
      {
        id: null,
        day_number: 0,
        day_off: true,
        time_from: '10:00',
        time_to: '14:00',
      },
      {
        id: null,
        day_number: 1,
        day_off: true,
        time_from: '10:00',
        time_to: '14:00',
      },
      {
        id: null,
        day_number: 2,
        day_off: true,
        time_from: '10:00',
        time_to: '14:00',
      },
      {
        id: null,
        day_number: 3,
        day_off: true,
        time_from: '10:00',
        time_to: '14:00',
      },
      {
        id: null,
        day_number: 4,
        day_off: true,
        time_from: '10:00',
        time_to: '14:00',
      },
      {
        id: null,
        day_number: 5,
        day_off: true,
        time_from: '11:00',
        time_to: '23:00',
      },
      {
        id: null,
        day_number: 6,
        day_off: true,
        time_from: '10:00',
        time_to: '14:00',
      },
    ],
    services_rooms_attributes: [
      {
        room_id: '',
        total_seats: '',
        uuid: nanoid(),
      },
    ],
  });
  const { rooms } = useServiceForm();

  const [errors, setErrors] = useState({});
  const [possibleServices, setPossibleServices] = useState([]);
  const [possibleServicesFetched, setPossibleServicesFetched] = useState(false);
  const [isCreatingServices, setIsCreatingServices] = useState(false);
  const [servicesList, setServicesList] = useState([]);
  const [isLoadingServices, setIsLoadingServices] = useState(false);

  const { currentRestaurant, handleSetModalData } = useCommon();
  const {
    handleCreateOrUpdate,
    inProcess: restaurantUpdateInProcess,
  } = useCurrentRestaurant();

  const { api: ipraticoApi } = useDynamicApi(IpraticoApi);
  const { api: servicesApi } = useDynamicApi(RestaurantServicesApi);

  const servicesApiInstance = useMemo(() => {
    if (!currentRestaurant?.id) return null;
    return new ServicesApi(currentRestaurant.id);
  }, [currentRestaurant]);

  const restaurantServicesApi = useMemo(() => {
    if (!currentRestaurant?.id) return null;
    return new RestaurantServicesApi(currentRestaurant.id);
  }, [currentRestaurant]);

  const {
    handleGetSettings,
    getInProcess,
    data,
    handleUpdate,
    updateInProcess,
  } = useSettings();

  const settingsApi = useMemo(() => {
    if (!currentRestaurant?.id) return null;
    return new SettingsApi(currentRestaurant.id);
  }, [currentRestaurant]);

  useEffect(() => {
    if (currentRestaurant?.id) {
      handleGetSettings();
    }
  }, [currentRestaurant?.id]);

  useEffect(() => {
    if (data) {
      setIpraticoData((s) => ({
        ...s,
        ipratico_key: data?.ipratico_key,
        ipratico_service_charge_id: data?.ipratico_service_charge_id,
      }));
    }
  }, [data]);

  const handleChangeVisibility = useCallback(
    (e) => {
      const {
        target: { checked },
      } = e;
      const data = new FormData();
      data.append('disabled', !checked);

      if (!checked) {
        handleSetModalData({
          title: 'Chiudi ora',
          body: (
            <>
              <StyledBodyText>
                Sei sicuro di voler chiudere ora
                <StyledBodyTextBold>
                  {' '}
                  {currentRestaurant?.title}?
                </StyledBodyTextBold>
              </StyledBodyText>
              <br />
              <StyledFlexbox justify='center'>
                <StyledBodyText as='span'>
                  Con questo interruttore non sei più visibile sulla
                  piattaforma. Quando vuoi tornare online, riattivalo
                  manualmente. Vuoi procedere?
                </StyledBodyText>
              </StyledFlexbox>
            </>
          ),
          open: true,
          itemData: {
            id: currentRestaurant?.id,
            data,
            route: false,
            restaurantDisabledAction: true,
          },
          variant: 'update',
        });
      } else {
        handleCreateOrUpdate(data, currentRestaurant?.id, false, true, {
          restaurantDisabledAction: true,
        });
      }
    },
    [currentRestaurant, handleSetModalData, handleCreateOrUpdate],
  );

  const onSelectTime = useCallback((e, index) => {
    const {
      target: { name, value },
    } = e;
    const [itemName, day_number] = name.split('-');

    setServiceLocalState((prev) => {
      const updatedHours = prev.service_opening_hours_attributes.map((i) => {
        if (i.day_number === parseInt(day_number)) {
          return {
            ...i,
            [itemName]: value,
          };
        }
        return i;
      });

      return {
        ...prev,
        service_opening_hours_attributes: updatedHours,
      };
    });
  }, []);

  const onChangeServiceForm = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setServiceLocalState((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  }, []);

  const onClickChip = useCallback(
    (item) => {
      setServiceLocalState((prev) => {
        const [day_number] = item.id.split('-');

        const updatedHours = prev.service_opening_hours_attributes.map((i) => {
          if (i.day_number === parseInt(day_number)) {
            return {
              ...i,
              day_off: !i.day_off,
            };
          }
          return i;
        });

        return {
          ...prev,
          service_opening_hours_attributes: updatedHours,
        };
      });
    },
    [serviceLocalState.service_opening_hours_attributes],
  );

  const onChangeRoom = useCallback((name, value, item) => {
    setServiceLocalState((prev) => {
      const services_rooms_attributes = prev.services_rooms_attributes.map(
        (room) => {
          if (room.uuid === item.uuid) {
            return {
              ...room,
              [name]: value,
            };
          }
          return room;
        },
      );

      return {
        ...prev,
        services_rooms_attributes,
      };
    });
  }, []);

  const onChangeService = useCallback(
    (e, index) => {
      const { name, value } = e.target;
      setServiceLocalState((prev) => ({
        ...prev,
        services: (prev.services || []).map((service, i) => {
          if (i === index) {
            if (name === 'total_seats') {
              const numValue = value === '' ? '' : parseInt(value) || 0;
              const maxSeats = possibleServices?.[index]?.max_total_seats;
              if (
                typeof numValue === 'number' &&
                maxSeats &&
                numValue > maxSeats
              ) {
                return {
                  ...service,
                  [name]: maxSeats,
                };
              }
              return {
                ...service,
                [name]: numValue,
              };
            }
            return {
              ...service,
              [name]: value,
            };
          }
          return service;
        }),
      }));
    },
    [possibleServices],
  );

  const onChangeServiceRoom = useCallback((roomId, value) => {
    setServiceLocalState((prev) => ({
      ...prev,
      serviceRooms: {
        ...(prev.serviceRooms || {}),
        [roomId]: value,
      },
    }));
  }, []);

  const onChangeRoomsCount = useCallback((roomId, count) => {
    setServiceLocalState((prev) => ({
      ...prev,
      roomsCount: {
        ...(prev.roomsCount || {}),
        [roomId]: count,
      },
    }));
  }, []);

  const onClickRoomsCount = useCallback((roomId) => {
    setServiceLocalState((prev) => ({
      ...prev,
      selectedRooms: [...(prev.selectedRooms || []), roomId],
    }));
  }, []);

  const onChangeRoomItem = useCallback((roomId, item) => {
    setServiceLocalState((prev) => ({
      ...prev,
      rooms: prev.rooms.map((r) => (r.id === roomId ? { ...r, ...item } : r)),
    }));
  }, []);

  const onClickAddRoom = useCallback(() => {
    const newRoom = {
      id: Date.now(),
      name: '',
      capacity: 0,
    };
    setServiceLocalState((prev) => ({
      ...prev,
      rooms: [...prev.rooms, newRoom],
    }));
  }, []);

  const onChangeConfigTabKey = useCallback((tab) => {
    setConfigTabKey(tab);
  }, []);

  useEffect(() => {
    const selected = [];
    ['table_reservation', 'takeaway', 'delivery'].forEach((i) => {
      if (localState && localState[i]) {
        selected.push(i);
      }
    });
    setSelectedValues(selected);
  }, [localState]);

  const showMainContent = true;
  // localState &&
  // (localState.delivery ||
  //   localState.table_reservation ||
  //   localState.takeaway);

  const isIpratico = useMemo(() => {
    return !!data.ipratico_active;
  }, [data]);

  useEffect(() => {
    setTabConfigured(true);
    setMainActiveTab(
      isIpratico ? SettingTabKeys.ipratico : SettingTabKeys.main,
    );
  }, [isIpratico]);

  const onChangeConfigs = useCallback(async () => {
    setConfigChangeInProcess(true);
    try {
      await ipraticoApi.get('destroy_all');
      handleGetSettings();
      setNeedConfirm(false);
    } catch (e) {
      console.log('er', e);
    } finally {
      setConfigChangeInProcess(false);
    }
  }, [handleGetSettings, ipraticoApi]);

  const onChangeMainTab = useCallback(
    (key) => {
      if (mainActiveTab !== key) {
        setNeedConfirm(true);
      }
    },
    [mainActiveTab],
  );

  const fetchPossibleServices = useCallback(async () => {
    try {
      if (!restaurantServicesApi) return;
      setPossibleServicesFetched(false);
      const { data } = await restaurantServicesApi.getPossibleServices();
      if (data.success && Array.isArray(data.possible_services)) {
        setPossibleServices(data.possible_services);
      } else {
        setPossibleServices([]);
      }
    } catch (error) {
      console.error('Error fetching possible services:', error);
      setPossibleServices([]);
    } finally {
      setPossibleServicesFetched(true);
    }
  }, [restaurantServicesApi]);

  useEffect(() => {
    if (openAutoCreateService) {
      fetchPossibleServices();
    }
  }, [openAutoCreateService, fetchPossibleServices]);

  useEffect(() => {
    if (
      possibleServices &&
      Array.isArray(possibleServices) &&
      possibleServices.length > 0 &&
      (!serviceLocalState.services || serviceLocalState.services.length === 0)
    ) {
      setServiceLocalState((prev) => ({
        ...prev,
        services: possibleServices.map((service) => ({
          title: '',
          total_seats: '',
          week_days: service?.week_days || [],
          interval: service?.interval || [],
        })),
      }));
    }
  }, [possibleServices]);

  const fetchServicesList = useCallback(async () => {
    console.log(
      `[MainLayoutV2.js::549]:servicesApiInstance`,
      servicesApiInstance,
    );
    if (!servicesApiInstance) {
      return;
    }

    setIsLoadingServices(true);
    try {
      const services = await fetchAllPagesFromListApi(servicesApiInstance, {
        itemsKey: 'services',
      });
      setServicesList(services || []);
    } catch (error) {
      console.error('fetchServicesList: Error fetching services:', error);
      setErrors(
        error?.response?.data || {
          message: 'Failed to fetch services',
        },
      );
    } finally {
      setIsLoadingServices(false);
    }
  }, [servicesApiInstance]);

  const handleDeleteService = useCallback(
    async (service) => {
      if (!servicesApiInstance) return;

      setIsCreatingServices(true);
      try {
        await servicesApiInstance.destroy(service.id);
        await fetchServicesList(); // Оновлюємо список після видалення
        UIHelper.showSuccessMessage('Servizio eliminato con successo');
      } catch (error) {
        console.error('Error deleting service:', error);
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Errore durante l'eliminazione del servizio";
        UIHelper.showError(errorMessage);
        setErrors(
          error?.response?.data || {
            message: 'Failed to delete service',
          },
        );
      } finally {
        setIsCreatingServices(false);
      }
    },
    [servicesApiInstance, fetchServicesList],
  );

  const handleCreateServices = useCallback(async () => {
    if (!restaurantServicesApi) {
      console.error('RestaurantServicesApi instance not available');
      return;
    }

    setIsCreatingServices(true);
    try {
      const payload = {
        possible_services: (serviceLocalState.services || []).map(
          (service) => ({
            title: service.title,
            total_seats:
              typeof service.total_seats === 'number'
                ? service.total_seats
                : parseInt(service.total_seats) || 0,
            week_days: service.week_days,
            interval: service.interval,
          }),
        ),
      };

      await restaurantServicesApi.createPossibleServices({
        data: payload,
      });
      setOpenAutoCreateService(false);
      setStep(1); // Переходимо до списку сервісів
      await fetchServicesList(); // Оновлюємо список
      UIHelper.showSuccessMessage('Servizi creati con successo');
    } catch (error) {
      console.error('Error creating services:', error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Errore durante la creazione dei servizi';
      UIHelper.showError(errorMessage);
      if (error.response?.data?.errors) {
        // Server validation errors
        const apiErrors = error.response.data.errors;
        if (typeof apiErrors === 'object' && apiErrors !== null) {
          setErrors(apiErrors);
        } else {
          setErrors({
            general: 'Errore durante la creazione del servizio',
          });
        }
      } else if (error.response?.data?.error) {
        // Single error message
        setErrors({ general: error.response.data.error });
      } else if (error.response?.data?.message) {
        // Error with message field
        setErrors({ general: error.response.data.message });
      } else if (typeof error.response?.data === 'string') {
        // Plain string error
        setErrors({ general: error.response.data });
      } else {
        // Default error message
        setErrors({
          general: 'Errore durante la creazione del servizio',
        });
      }
    } finally {
      setIsCreatingServices(false);
    }
  }, [serviceLocalState, restaurantServicesApi, fetchServicesList]);

  useEffect(() => {
    if (step === 3) {
      fetchServicesList();
    }
  }, [step, fetchServicesList]);

  // New function for editing services
  const handleEditService = useCallback(
    async (serviceId) => {
      if (!servicesApiInstance) {
        console.error('ServicesApi instance not available');
        return;
      }

      setIsCreatingServices(true);
      setErrors({});

      try {
        // Fetch service data for editing
        const { data } = await servicesApiInstance.get(serviceId);
        const service = data.service;

        // Transform the service data to match our form structure
        const transformedService = {
          id: service.id,
          title: service.title || '',
          total_seats: service.total_seats || 1,
          service_duration: service.service_duration || '180_minutes',
          prereservation_time: service.prereservation_time || 'none',
          confirmation_type: service.confirmation_type || 'none',
          slot_duration: service.slot_duration || '30_minutes',
          slot_seats: service.slot_seats || 3,
          price: service.price || '1',
          booking_max_person_count: service.booking_max_person_count || 6,
          auto_confirmation:
            service.auto_confirmation !== undefined
              ? service.auto_confirmation
              : true,
          auto_confirmation_type: service.auto_confirmation_type || 'always',
          service_opening_hours_attributes: (() => {
            // If we have existing opening hours, use them
            if (
              service.service_opening_hours &&
              Array.isArray(service.service_opening_hours) &&
              service.service_opening_hours.length === 7
            ) {
              return service.service_opening_hours.map((hour) => ({
                id: hour.id,
                day_number: hour.day_number,
                day_off: hour.day_off,
                time_from: hour.time_from || '10:00',
                time_to: hour.time_to || '14:00',
              }));
            }

            // Otherwise, use default structure
            return [
              {
                id: null,
                day_number: 0,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 1,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 2,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 3,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 4,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 5,
                day_off: true,
                time_from: '11:00',
                time_to: '23:00',
              },
              {
                id: null,
                day_number: 6,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
            ];
          })(),
          services_rooms_attributes: service.services_rooms?.map((room) => ({
            room_id: room?.id?.toString() || '',
            roomId: room?.room.id?.toString() || '',
            total_seats: room.total_seats?.toString() || '',
            uuid: nanoid(),
          })) || [
            {
              room_id: '',
              roomId: '',
              total_seats: '',
              uuid: nanoid(),
            },
          ],
        };

        setServiceLocalState(transformedService);
        setStep(4); // Go to edit form
      } catch (error) {
        console.error('Error fetching service for editing:', error);
        UIHelper.showError('Errore durante il caricamento del servizio');
      } finally {
        setIsCreatingServices(false);
      }
    },
    [servicesApiInstance],
  );

  // Updated function to handle both create and update
  const handleServiceFormSubmit = useCallback(
    async (e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      // Validate form
      const validationErrors = {};

      if (!serviceLocalState.title || serviceLocalState.title.trim() === '') {
        validationErrors.title = 'Il titolo del servizio è obbligatorio';
      }

      if (
        !serviceLocalState.total_seats ||
        parseInt(serviceLocalState.total_seats) <= 0
      ) {
        validationErrors.total_seats =
          'Il numero totale di coperti deve essere maggiore di 0';
      }

      if (
        !serviceLocalState.booking_max_person_count ||
        parseInt(serviceLocalState.booking_max_person_count) <= 0
      ) {
        validationErrors.booking_max_person_count =
          'Il numero massimo di persone per tavolo deve essere maggiore di 0';
      }

      if (
        !serviceLocalState.slot_seats ||
        parseInt(serviceLocalState.slot_seats) <= 0
      ) {
        validationErrors.slot_seats =
          'Il numero di coperti per fascia oraria deve essere maggiore di 0';
      }

      // Validate service_opening_hours_attributes
      if (
        !serviceLocalState.service_opening_hours_attributes ||
        serviceLocalState.service_opening_hours_attributes.length !== 7
      ) {
        validationErrors.service_opening_hours =
          'Gli orari di apertura devono includere tutti i 7 giorni della settimana';
      } else {
        // Check for unique day_numbers
        const dayNumbers = serviceLocalState.service_opening_hours_attributes.map(
          (day) => day.day_number,
        );
        const uniqueDayNumbers = [...new Set(dayNumbers)];
        if (uniqueDayNumbers.length !== 7) {
          validationErrors.service_opening_hours =
            'Ogni giorno della settimana deve essere unico';
        }

        // Check that day_numbers are from 0 to 6
        const validDayNumbers = dayNumbers.every((day) => day >= 0 && day <= 6);
        if (!validDayNumbers) {
          validationErrors.service_opening_hours =
            'I giorni devono essere numerati da 0 a 6 (Lunedì a Domenica)';
        }
      }

      // Validate rooms only if they are selected
      if (
        serviceLocalState.services_rooms_attributes &&
        serviceLocalState.services_rooms_attributes.length > 0
      ) {
        serviceLocalState.services_rooms_attributes.forEach((room, index) => {
          if (
            room.room_id &&
            (!room.total_seats || parseInt(room.total_seats) <= 0)
          ) {
            validationErrors[`services_rooms_attributes.${index}.total_seats`] =
              'Il numero di coperti deve essere maggiore di 0';
          }
        });
      }

      if (Object.keys(validationErrors).length > 0) {
        // Ensure all error values are strings
        const formattedErrors = {};
        Object.keys(validationErrors).forEach((key) => {
          const error = validationErrors[key];
          if (typeof error === 'string') {
            formattedErrors[key] = error;
          } else if (Array.isArray(error)) {
            formattedErrors[key] = error.join(' ');
          } else {
            formattedErrors[key] = String(error);
          }
        });
        setErrors(formattedErrors);
        return;
      }

      setIsCreatingServices(true);
      setErrors({});

      try {
        if (!servicesApiInstance) {
          console.error('ServicesApi instance not available');
          return;
        }

        // Prepare the data for API
        const filteredRooms = serviceLocalState.services_rooms_attributes
          .filter((room) => room.roomId && room.total_seats)
          .map((room) => {
            const roomObj = {
              total_seats: Number(room.total_seats),
              room_id: Number(room.roomId),
            };
            if (Number(room.room_id) > 0) {
              roomObj.id = Number(room.room_id);
            }
            if (room._destroy) {
              roomObj._destroy = true;
            }
            return roomObj;
          });

        const serviceData = {
          service: {
            title: serviceLocalState.title,
            total_seats: Number(serviceLocalState.total_seats) || 1,
            service_duration: serviceLocalState.service_duration,
            prereservation_time: serviceLocalState.prereservation_time,
            confirmation_type: serviceLocalState.confirmation_type,
            slot_duration: serviceLocalState.slot_duration,
            slot_seats: Number(serviceLocalState.slot_seats) || 3,
            price: serviceLocalState.price || '1',
            booking_max_person_count:
              Number(serviceLocalState.booking_max_person_count) || 6,
            auto_confirmation: serviceLocalState.auto_confirmation,
            auto_confirmation_type: serviceLocalState.auto_confirmation_type,
            service_opening_hours_attributes: serviceLocalState.service_opening_hours_attributes
              .filter((day) => day.day_number >= 0 && day.day_number <= 6) // Тільки дні 0-6 (понеділок-неділя)
              .slice(0, 7) // Максимум 7 днів
              .sort((a, b) => a.day_number - b.day_number) // Сортуємо за day_number
              .map((day) => {
                const dayData = {
                  day_number: Number(day.day_number),
                  day_off: Boolean(day.day_off),
                };

                // Only include time_from and time_to if it's not a day off
                if (!day.day_off) {
                  dayData.time_from = day.time_from;
                  dayData.time_to = day.time_to;
                }

                // Include id only if it exists and is not null (for updates)
                if (day.id && day.id !== null && day.id !== undefined) {
                  dayData.id = day.id;
                }

                return dayData;
              }),
          },
        };

        // Переконаємося, що у нас точно 7 днів
        if (serviceData.service.service_opening_hours_attributes.length !== 7) {
          console.error('Service opening hours must have exactly 7 days');
          setErrors({
            general:
              'Gli orari di apertura devono includere tutti i 7 giorni della settimana',
          });
          return;
        }

        // Перевіряємо на дублікати днів
        const dayNumbers = serviceData.service.service_opening_hours_attributes.map(
          (day) => day.day_number,
        );
        const uniqueDayNumbers = [...new Set(dayNumbers)];
        if (uniqueDayNumbers.length !== 7) {
          console.error('Duplicate day numbers found:', dayNumbers);
          setErrors({
            general: 'Ogni giorno della settimana deve essere unico',
          });
          return;
        }

        // Only include services_rooms_attributes if there are rooms
        if (filteredRooms.length > 0) {
          serviceData.service.services_rooms_attributes = filteredRooms;
        }

        let response;
        if (serviceLocalState.id) {
          // Update existing service
          response = await servicesApiInstance.put(serviceLocalState.id, {
            data: serviceData,
          });
          UIHelper.showSuccessMessage('Servizio aggiornato con successo');
        } else {
          // Create new service
          response = await servicesApiInstance.create({
            data: serviceData,
          });
          UIHelper.showSuccessMessage('Servizio creato con successo');
        }

        // Check for successful response (200 for create, 204 for update)
        if (response.status === 200 || response.status === 204) {
          try {
            await fetchServicesList();
          } catch (error) {
            console.error('Error fetching services list after save:', error);
            // Continue with navigation even if fetch fails
          }

          // Force navigation to step 3 with multiple approaches
          setStep(3); // Go back to services list

          // Force re-render with setTimeout and functional form
          setTimeout(() => {
            setStep((prevStep) => {
              return 1;
            });
          }, 0);

          // Reset form to initial state
          setServiceLocalState({
            id: null,
            title: '',
            total_seats: 1,
            service_duration: '180_minutes',
            prereservation_time: 'none',
            confirmation_type: 'none',
            slot_duration: '30_minutes',
            slot_seats: 3,
            price: '1',
            booking_max_person_count: 6,
            auto_confirmation: true,
            auto_confirmation_type: 'always',
            service_opening_hours_attributes: [
              {
                id: null,
                day_number: 0,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 1,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 2,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 3,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 4,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
              {
                id: null,
                day_number: 5,
                day_off: true,
                time_from: '11:00',
                time_to: '23:00',
              },
              {
                id: null,
                day_number: 6,
                day_off: true,
                time_from: '10:00',
                time_to: '14:00',
              },
            ],
            services_rooms_attributes: [
              {
                room_id: '',
                total_seats: '',
                uuid: nanoid(),
              },
            ],
          });
        }
      } catch (error) {
        console.error('Error saving service:', error);
        console.error('Error response:', error.response);
        console.error('Error response data:', error.response?.data);
        console.error('Error response status:', error.response?.status);

        // Check if we have validation errors directly in response data
        if (error.response?.data && typeof error.response.data === 'object') {
          const responseData = error.response.data;
          const formattedErrors = {};

          // Process each error field
          Object.keys(responseData).forEach((key) => {
            const errorValue = responseData[key];
            let formattedError = '';

            // Special handling for service_opening_hours errors
            if (key === 'service_opening_hours' && Array.isArray(errorValue)) {
              formattedError = errorValue.join('; ');
              formattedErrors[key] = formattedError;
              return;
            }

            // Special handling for service_opening_hours.day_number errors
            if (
              key === 'service_opening_hours.day_number' &&
              Array.isArray(errorValue)
            ) {
              // Parse day-specific errors like [{"0": "Error message"}]
              errorValue.forEach((item) => {
                if (typeof item === 'object' && item !== null) {
                  Object.keys(item).forEach((dayKey) => {
                    const message = item[dayKey];
                    if (typeof message === 'string') {
                      // Create separate error for each day
                      formattedErrors[
                        `service_opening_hours.day_${dayKey}`
                      ] = message;
                    }
                  });
                }
              });
              // Don't process this key further
              return;
            }

            // Special handling for service_opening_hours.service_id errors
            if (
              key === 'service_opening_hours.service_id' &&
              Array.isArray(errorValue)
            ) {
              formattedError = errorValue.join('; ');
              formattedErrors['service_opening_hours'] = formattedError;
              return;
            }

            // Special handling for service_id errors (when service already exists)
            if (key === 'service_id' && Array.isArray(errorValue)) {
              formattedError = errorValue.join('; ');
              formattedErrors['general'] = formattedError;
              return;
            }

            // General array handling for other fields
            else if (Array.isArray(errorValue)) {
              const errorMessages = [];
              errorValue.forEach((item) => {
                if (typeof item === 'string') {
                  errorMessages.push(item);
                } else if (typeof item === 'object' && item !== null) {
                  Object.keys(item).forEach((objKey) => {
                    const message = item[objKey];
                    if (typeof message === 'string') {
                      errorMessages.push(`${objKey}: ${message}`);
                    }
                  });
                }
              });
              formattedError =
                errorMessages.length > 0
                  ? errorMessages.join('; ')
                  : errorValue.join(' ');
            }
            // Keep strings as is
            else if (typeof errorValue === 'string') {
              formattedError = errorValue;
            }
            // Handle single objects
            else if (typeof errorValue === 'object' && errorValue !== null) {
              const errorMessages = [];
              Object.keys(errorValue).forEach((objKey) => {
                const message = errorValue[objKey];
                if (typeof message === 'string') {
                  errorMessages.push(`${objKey}: ${message}`);
                }
              });
              formattedError =
                errorMessages.length > 0
                  ? errorMessages.join('; ')
                  : JSON.stringify(errorValue);
            }
            // Convert anything else to string
            else {
              formattedError = String(errorValue);
            }

            // Ensure the error is a string and not empty
            if (
              formattedError &&
              typeof formattedError === 'string' &&
              formattedError !== '[object Object]'
            ) {
              formattedErrors[key] = formattedError;
            }
          });

          // Check if we have any errors to set
          if (Object.keys(formattedErrors).length > 0) {
            // Double-check all values are strings to prevent React error #31
            const safeErrors = {};
            Object.keys(formattedErrors).forEach((key) => {
              const value = formattedErrors[key];
              if (typeof value === 'string') {
                safeErrors[key] = value;
              } else if (Array.isArray(value)) {
                safeErrors[key] = value.join(' ');
              } else {
                safeErrors[key] = String(value);
              }
            });

            setErrors(safeErrors);
          } else {
            setErrors({
              general: 'Errore durante il salvataggio del servizio',
            });
          }
        } else {
          setErrors({
            general: 'Errore durante il salvataggio del servizio',
          });
        }

        // Show error message
        const errorMessage = serviceLocalState.id
          ? "Errore durante l'aggiornamento del servizio"
          : 'Errore durante la creazione del servizio';
        UIHelper.showError(errorMessage);
      } finally {
        setIsCreatingServices(false);
      }
    },
    [serviceLocalState, servicesApiInstance, fetchServicesList],
  );

  const handleSavePrenotazioneTavoliSettings = useCallback(async () => {
    try {
      setIsCreatingServices(true);

      // 1. Зберігаємо статус активації сервісу prenotazione tavoli
      if (handleUpdate) {
        await handleUpdate({
          settings: {
            table_reservation: showContent, // зберігаємо статус чекбокса
          },
        });
      } else {
        console.warn('handleUpdate is not available');
      }

      // 2. Зберігаємо розклад роботи якщо є зміни
      if (deliveryDates && deliveryActiveTab && settingsApi) {
        await settingsApi.updateOpeningHours(
          deliveryActiveTab,
          deliveryDates[deliveryActiveTab],
        );

        // Оновлюємо дані з сервера
        const { data: newData } = await settingsApi.get(
          `opening_hours/${deliveryActiveTab}`,
        );

        setDeliveryDates((state) => ({
          ...state,
          [deliveryActiveTab]: {
            ...state[deliveryActiveTab],
            isFetched: true,
            errors: null,
            ...newData,
          },
        }));
      } else {
        console.warn('Cannot save opening hours - missing dependencies:', {
          deliveryDates: !!deliveryDates,
          deliveryActiveTab: !!deliveryActiveTab,
          settingsApi: !!settingsApi,
        });
      }

      UIHelper.showSuccessMessage('Impostazioni salvate con successo');
      return true;
    } catch (error) {
      console.error('Error saving prenotazione tavoli settings:', error);

      if (error?.response?.data?.opening_hours) {
        setOpeningHourErrors(error.response.data.opening_hours);
      }

      UIHelper.showError('Errore durante il salvataggio delle impostazioni');
      return false;
    } finally {
      setIsCreatingServices(false);
    }
  }, [
    handleUpdate,
    settingsApi,
    showContent,
    deliveryDates,
    deliveryActiveTab,
    setOpeningHourErrors,
    setDeliveryDates,
  ]);

  const STORAGE_KEY = 'opening_times_checkboxes_state';
  const saveReservationCheckbox = (restaurantId, value) => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      const allStates = saved ? JSON.parse(saved) : {};

      if (!allStates[restaurantId]) allStates[restaurantId] = {};

      allStates[restaurantId].reservation = value;

      localStorage.setItem(STORAGE_KEY, JSON.stringify(allStates));
    } catch (error) {
      console.error('Error saving reservation checkbox:', error);
    }
  };

  const loadReservationCheckbox = (restaurantId) => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) return false;

      const parsed = JSON.parse(saved);
      return parsed[restaurantId]?.reservation || false;
    } catch (error) {
      console.error('Error reading reservation checkbox:', error);
      return false;
    }
  };

  useEffect(() => {
    fetchServicesList();
  }, [currentRestaurant, servicesApiInstance]);

  return (
    <Layout>
      <PageTitle />
      <StyledMenuWrapper style={{ flex: 1, flexDirection: 'column' }}>
        {!getInProcess ? (
          <StyledFormBlockWrapper
            as='form'
            onSubmit={onSubmitAction}
            desktopMl={0}
            style={{
              minHeight: '100%',
              flexDirection: 'column',
              display: mainActiveTab === SettingTabKeys.main ? 'block' : 'flex',
            }}
          >
            {step === 1 && (
              <>
                <Header>
                  <HeaderTitle>Impostazioni</HeaderTitle>
                </Header>
                <div style={{}}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '20px',
                      padding: '30px 20px',
                      color: '#636262',
                    }}
                  >
                    <Title>Visibilità sulla piattaforma</Title>
                    <StyledFlexbox
                      align='center'
                      justify='flex-start'
                      marginTop={12}
                      style={{ gap: '35px' }}
                    >
                      <Typography
                        mb={0}
                        style={{
                          display: 'inline-block',
                          flex: '0 1 auto',
                        }}
                      >
                        {!currentRestaurant?.disabled ? (
                          <>
                            Scorri lo switch per non essere più
                            <br />
                            visibile sulla piattaforma
                          </>
                        ) : (
                          'Per aprire ora scorri lo switch.'
                        )}
                      </Typography>
                      <SwitchCheckbox
                        name='restaurant_disabled'
                        onChange={handleChangeVisibility}
                        checked={!currentRestaurant?.disabled}
                        disabled={restaurantUpdateInProcess}
                        style={{ flexShrink: 0 }}
                      />
                    </StyledFlexbox>
                    <Title>GESTIONE SERVIZIO DI PRENOTAZIONE TAVOLI</Title>
                  </div>
                </div>
                {showContent && (
                  <>
                    {showMainContent && (
                      <>
                        <Divider style={{ width: '100%' }} />
                        <TimesForm
                          data={data}
                          setOpeningHourErrors={setOpeningHourErrors}
                          changeDeliveryDayConfig={changeDeliveryDayConfig}
                          deliveryActiveTab={deliveryActiveTab}
                          deliveryDates={deliveryDates}
                          fetchDeliveryDates={fetchDeliveryDates}
                          onChangeDeliveryTab={onChangeDeliveryTab}
                          onChangeMaximum={onChangeMaximum}
                          onChangeExceptionDay={onChangeExceptionDay}
                          onAddExceptionData={onAddExceptionData}
                          deliveryLoading={isCreatingServices}
                          openingHourErrors={openingHourErrors}
                          onDeleteException={onDeleteException}
                          onAddNewException={onAddNewException}
                          exceptionErrors={exceptionErrors}
                        />
                        {children}
                      </>
                    )}
                  </>
                )}
                {step === 1 && (
                  <div style={{ padding: '20px' }}>
                    <ExceptionsWrapper p='20px 20px 30px 20px'>
                      <InputTitle mb={0}>
                        CONFIGURA I SERVIZI DI PRENOTAZIONE
                      </InputTitle>
                      <Button
                        style={{ marginTop: '20px' }}
                        color='action'
                        maxW='320px'
                        width='320px'
                        type='button'
                        onClick={() => {
                          setStep(2);
                        }}
                      >
                        AVVIA LA CONFIGURAZIONE
                      </Button>
                    </ExceptionsWrapper>
                    <ServicesList
                      list={servicesList}
                      onDelete={handleDeleteService}
                      onEdit={handleEditService}
                      inProcess={isLoadingServices || isCreatingServices}
                      isSuperAdmin={isSuperAdmin}
                      currentRestaurant={currentRestaurant}
                    />
                    <button
                      style={{
                        backgroundColor: 'transparent',
                        color: '#FF7828',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        marginTop: '20px',
                        marginLeft: '20px',
                        marginBottom: '20px',
                      }}
                      type='button'
                      onClick={() => setStep(4)}
                    >
                      <span>+ Crea servizio manualmente</span>
                    </button>
                  </div>
                )}
                {/* {showFooter && showContent && (
                  <FormFooter
                    mobPadding='20px'
                    style={{ marginTop: 0 }}
                    isForm={false}
                    hideCancel={true}
                    submitText='Configura i servizi'
                    onSave={() => {
                      console.log('onSave');
                      setStep(2);
                    }}
                    inProcess={
                      updateInProcess ||
                      localUpdateInProcess ||
                      ipraticoInProcess
                    }
                    onCancel={onCancel}
                    submitPadding='10px 45px'
                    submitMaxW='210px'
                  />
                )} */}
              </>
            )}
            {step === 2 && (
              <>
                <Header>
                  <HeaderTitle>Configura i servizi</HeaderTitle>
                </Header>
                <div style={{}}>
                  <ServicesContent
                    data={data}
                    activeTabKey={deliveryActiveTab}
                    onChangeTab={onChangeDeliveryTab}
                    currentRestaurant={currentRestaurant}
                    hideSwitcher
                    hideTitle
                    text={`Qui puoi creare automaticamente i servizi di prenotazione tavoli in base alle fasce orarie da te inserite. Il sistema crea un servizio per ogni fascia oraria inserita. Per esempio, se a pranzo il locale è aperto dalle 12 alle 14, dal lunedì al venerdì e dalle 12 alle 15, il sabato e la domenica, il sistema crea due servizi di prenotazione, uno valido dal lunedì al venerdì e uno per il sabato e la domenica. In fase di creazione, puoi dare un nome al servizio  e impostare il numero massimo di coperti prenotabili. Di deafult questo valore è pari al 20% dei coperti disponibili.`}
                    hideCreateService
                  />

                  {openAutoCreateService && (
                    <div
                      style={{
                        color: '#636262',
                        paddingLeft: '20px',
                        paddingRight: '20px',
                      }}
                    >
                      <div style={{}}>
                        {possibleServices &&
                          Array.isArray(possibleServices) &&
                          possibleServices.map((service, index) => (
                            <div
                              key={index}
                              style={{
                                marginBottom: '20px',
                              }}
                            >
                              <div
                                style={{
                                  marginTop: '20px',
                                }}
                              >
                                <InputDescription
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    marginBottom: '12px',
                                  }}
                                >
                                  Giorni
                                </InputDescription>
                                <div
                                  style={{
                                    fontSize: '14px',
                                    color: '#636262',
                                  }}
                                >
                                  {service?.week_days &&
                                  Array.isArray(service.week_days)
                                    ? service.week_days
                                        .map((day) => {
                                          const days = [
                                            'Lunedì',
                                            'Martedì',
                                            'Mercoledì',
                                            'Giovedì',
                                            'Venerdì',
                                            'Sabato',
                                            'Domenica',
                                          ];
                                          return days[day];
                                        })
                                        .join(', ')
                                    : 'N/A'}
                                </div>
                              </div>

                              <div
                                style={{
                                  marginTop: '20px',
                                }}
                              >
                                <InputDescription
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    marginBottom: '12px',
                                  }}
                                >
                                  Fascia oraria:
                                </InputDescription>
                                <div
                                  style={{
                                    fontSize: '14px',
                                    color: '#636262',
                                  }}
                                >
                                  {service?.interval &&
                                  Array.isArray(service.interval) &&
                                  service.interval[0] &&
                                  service.interval[1]
                                    ? `${service.interval[0]} - ${service.interval[1]}`
                                    : 'N/A'}
                                </div>
                              </div>
                              <InputDescription
                                style={{
                                  marginBottom: '20px',
                                }}
                              >
                                Scrivi il nome che identifica il servizio <br />{' '}
                                (esempi: pranzo o cena).
                              </InputDescription>
                              <Input
                                type='text'
                                name='title'
                                label='Nome del servizio'
                                value={
                                  serviceLocalState?.services?.[index]?.title ||
                                  ''
                                }
                                onChange={(e) => onChangeService(e, index)}
                                placeholder='Inserisci nome del servizio'
                                style={{}}
                              />
                              <InputDescription
                                style={{
                                  marginBottom: '20px',
                                }}
                              >
                                Indica il numero totale di coperti prenotabili
                                per questo servizio.
                              </InputDescription>
                              <Input
                                type='number'
                                name='total_seats'
                                label='Totale coperti prenotabili'
                                value={
                                  serviceLocalState?.services?.[
                                    index
                                  ]?.total_seats?.toString() || ''
                                }
                                onChange={(e) => onChangeService(e, index)}
                                placeholder='30'
                                max={service?.max_total_seats || 100}
                                min={1}
                                style={{}}
                              />
                              <Divider
                                style={{
                                  marginTop: 20,
                                  width: '100%',
                                }}
                              />
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      padding: '20px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      gap: '10px',
                    }}
                  >
                    <Button
                      color='action'
                      maxW='275px'
                      type='button'
                      disabled={
                        openAutoCreateService &&
                        possibleServicesFetched &&
                        possibleServices.length === 0
                      }
                      onClick={() => {
                        if (openAutoCreateService) {
                          if (
                            !possibleServicesFetched ||
                            possibleServices.length === 0
                          ) {
                            return;
                          }
                          handleCreateServices();
                          setOpenAutoCreateService(false);
                        } else {
                          setPossibleServicesFetched(false);
                          setOpenAutoCreateService(true);
                        }
                      }}
                    >
                      {openAutoCreateService ? (
                        <span>Conferma servizi automatici</span>
                      ) : (
                        <span>Crea servizi automaticamente</span>
                      )}
                    </Button>
                    {openAutoCreateService &&
                      possibleServicesFetched &&
                      possibleServices.length === 0 && (
                        <span
                          style={{
                            color: '#e53935',
                            fontSize: '14px',
                            maxWidth: '275px',
                          }}
                        >
                          Non ci sono i servizi disponibili
                        </span>
                      )}
                    <Button
                      color='action'
                      maxW='260px'
                      type='button'
                      onClick={() => setStep(4)}
                    >
                      <span>Crea manualmente</span>
                    </Button>
                  </div>
                </div>
              </>
            )}
            {step === 3 && (
              <>
                <Header>
                  <HeaderTitle>Configura i servizi</HeaderTitle>
                </Header>
                <div style={{}}>
                  <div
                    style={{
                      padding: '20px',
                      paddingTop: '30px',
                    }}
                  >
                    <Title>Crea servizi per fasce orarie</Title>
                  </div>
                  <ServicesList
                    list={servicesList}
                    onDelete={handleDeleteService}
                    onEdit={handleEditService}
                    inProcess={isLoadingServices || isCreatingServices}
                    isSuperAdmin={isSuperAdmin}
                    currentRestaurant={currentRestaurant}
                  />
                  <button
                    style={{
                      backgroundColor: 'transparent',
                      color: '#FF7828',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '500',
                      marginTop: '20px',
                      marginLeft: '20px',
                      marginBottom: '20px',
                    }}
                    type='button'
                    onClick={() => setStep(4)}
                  >
                    <span>+ Crea servizio manualmente</span>
                  </button>
                </div>
              </>
            )}
            {step === 4 && (
              <>
                <Header>
                  <HeaderTitle>
                    {serviceLocalState.id
                      ? 'Modifica servizio'
                      : 'Crea servizio'}
                  </HeaderTitle>
                </Header>
                <div
                  style={{
                    padding: '20px',
                    paddingTop: '30px',
                  }}
                >
                  <ServiceForm
                    rooms={rooms}
                    onChangeRoom={onChangeRoom}
                    localState={serviceLocalState}
                    onSelectTime={onSelectTime}
                    onChange={onChangeServiceForm}
                    onClickChip={onClickChip}
                    onChangeServiceRoom={onChangeServiceRoom}
                    onChangeRoomsCount={onChangeRoomsCount}
                    onClickRoomsCount={onClickRoomsCount}
                    onChangeRoomItem={onChangeRoomItem}
                    onClickAddRoom={onClickAddRoom}
                    errors={errors}
                    isEditMode={!!serviceLocalState.id}
                  />
                  <FormFooter
                    mobPadding='20px'
                    style={{ marginTop: 0 }}
                    isForm={true}
                    hideCancel={true}
                    submitText='Salva configurazione'
                    cancelText='Annulla'
                    onSave={handleServiceFormSubmit}
                    onCancel={() => setStep(1)}
                    isLoading={isCreatingServices}
                  />
                </div>
              </>
            )}
          </StyledFormBlockWrapper>
        ) : (
          <SettingsMainFormLoader />
        )}
      </StyledMenuWrapper>
    </Layout>
  );
};

export default SettingsMainLayout;
